window.Products.Bag.DayTote = function() {};
window.Products.Bag.DayTote.inherits(window.Products.Bag.Bag);
window.Products.Bag.DayTote.texturesLoading = false;
window.Products.Bag.DayTote.texturesLoaded = 0;
window.Products.Bag.DayTote.id = 63;
window.Products.Bag.DayTote.slug = 'day-tote';
window.Products.Bag.DayTote.has_3d = true;
window.Products.Bag.DayTote.dpi = 150;
window.Products.Bag.DayTote.rotate_fit = true;
window.Products.Bag.DayTote.fit_template_all = true;
window.Products.Bag.DayTote.preview_data = {
    texture_width: 2048,
    texture_height: 2048,
    scenes: {
        main: {
            deltax: [38,395],
            deltay: 67,
            originalWidth: 357,
            originalHeight: 391,
            scaleWidth: 956.5,
            scaleHeight: 1020,
            preview_x: [3,959.5],
            preview_y: 1024,
            ratio: 37.4,
            tools: ['mirror_side', 'fit_center', 'fit_side', 'rotation_assist', 'toggle_bleed'],
            warnings: [
                {x:40,y:69},
                {x:750,y:69},
                {x:750,y:456},
                {x:40,y:456},
                
                // middle point warning
                {x:332,y:154},
                {x:458,y:149},
                {x:332,y:374},
                {x:458,y:374},                
                {x:394,y:154},
                {x:394,y:368},                
                {x:426,y:154},
                {x:426,y:368},
                {x:362,y:154},
                {x:362,y:368}
            ]
        },
        back: {
            deltax: [38,395],
            deltay: 67,
            originalWidth: 357,
            originalHeight: 391,
            scaleWidth: 956.5,
            scaleHeight: 1020,
            preview_x: [3,959.5],
            preview_y: 0,
            ratio: 37.4,
            tools: ['mirror_side', 'fit_center', 'fit_side', 'rotation_assist', 'toggle_bleed'],
            warnings: [
                {x:40,y:69},
                {x:750,y:69},
                {x:750,y:456},
                {x:40,y:456},
                
                // middle point warning
                {x:332,y:154},
                {x:458,y:149},
                {x:332,y:374},
                {x:458,y:374},
                
                {x:394,y:154},
                {x:394,y:368},
                {x:426,y:154},
                {x:426,y:368},
                {x:362,y:154},
                {x:362,y:368}
            ]
        }
    }
};

window.Products.Bag.DayTote.prototype.set3dProperties = function(modelViewer) {
    var me = this;

    modelViewer.object.children[2].material.map = modelViewer.texture;
    modelViewer.object.children[2].material.map.minFilter = THREE.LinearMipMapLinearFilter;
    modelViewer.object.children[2].material.color = new THREE.Color(0.748900, 0.748900, 0.748900);
    modelViewer.object.children[2].material.bumpScale = 0.0025;
    modelViewer.object.children[2].material.needsUpdate = true; //Force update the material with the design
    
    modelViewer.object.children[0].material.map = modelViewer.texture;
    modelViewer.object.children[0].material.map.minFilter = THREE.LinearMipMapLinearFilter;
    modelViewer.object.children[0].material.color = new THREE.Color(0.748900, 0.748900, 0.748900);
    modelViewer.object.children[0].material.bumpScale = 0.0025;
    modelViewer.object.children[0].material.needsUpdate = true; //Force update the material with the design

    modelViewer.object.children[1].material.bumpScale = 0.01;
    modelViewer.object.children[1].material.needsUpdate = true; //Force update the material with the design

    modelViewer.object.position.y = -0.12;

    if(!me.envReady){
        me.loadEnvMap(function(){
            modelViewer.object.children[3].material.envMap = me.envMap;
            modelViewer.object.children[1].material.envMap = me.envMap;
            modelViewer.object.children[3].material.envMap.mapping = THREE.EquirectangularReflectionMapping;
            modelViewer.object.children[1].material.envMap.mapping = THREE.EquirectangularReflectionMapping;
            modelViewer.object.children[3].material.needsUpdate = true;
            modelViewer.object.children[3].material.envMap.needsUpdate = true;
            modelViewer.object.children[1].material.needsUpdate = true;
            modelViewer.object.children[1].material.envMap.needsUpdate = true;
        });
    }

    if(!me.texturesLoading && !me.texturesLoaded){
        me.loadTextures(function(){
            if(modelViewer.inlab) {
                me.setStrap('428', modelViewer);
            } else {
                $('#productInfo-productOption-strap-color').trigger('change');
            }
        });
    }
};

window.Products.Bag.DayTote.prototype.loadTextures = function(callback){
    var product = this;
    var sources = [   
        'textures/c_ao.jpg',
        'textures/p_ao.jpg',
        'textures/r_ao.jpg',
        'textures/r_color.jpg',
        'textures/s_ao.jpg' 
    ];
    product.texturesLoading = true;
    product.texturesLoaded = 0;
    product.textures = [];
    sources.forEach(function(src, index) {
        var textureLoader = new THREE.TextureLoader();
        textureLoader.crossOrigin = 'anonymous';

        var texture = textureLoader.load(THREE_JSON_URL + src, function(event){
            product.textures[index] = event;
            product.texturesLoading = false;
            product.texturesLoaded++;
            if(callback && product.texturesLoaded == sources.length){
                callback();
            }
        });
    });
};

window.Products.Bag.DayTote.prototype.setStrap = function(type, modelViewer){
    var me = this;    

    if(me.texturesLoading || !me.texturesLoaded) {
        return;
    }

    switch(type){
        case '429': // Cotton, Black
            modelViewer.object.children[3].material.map.image = modelViewer.product.textures[0].image;
            modelViewer.object.children[3].material.bumpMap.image = modelViewer.product.textures[0].image;
            modelViewer.object.children[3].material.color.r = 0.25;
            modelViewer.object.children[3].material.color.g = 0.23;
            modelViewer.object.children[3].material.color.b = 0.21;
            modelViewer.object.children[3].material.bumpScale = 0.02;
            modelViewer.object.children[3].material.shininess = 5.75;
            modelViewer.object.children[3].material.specular.r = 0.05;
            modelViewer.object.children[3].material.specular.g = 0.05;
            modelViewer.object.children[3].material.specular.b = 0.05;
            modelViewer.object.children[3].scale.y = 1;
            modelViewer.object.children[3].position.z = 0;
            modelViewer.object.children[1].scale.y = 1;
            modelViewer.object.children[1].position.z = 0;
            modelViewer.object.children[3].material.reflectivity = 0.025;
            modelViewer.object.children[1].material.reflectivity = 1;
            break;
        case '428': // Cotton, Natural
            modelViewer.object.children[3].material.map.image = modelViewer.product.textures[0].image;
            modelViewer.object.children[3].material.bumpMap.image = modelViewer.product.textures[0].image;
            modelViewer.object.children[3].material.color.r = 0.95;
            modelViewer.object.children[3].material.color.g = 0.90;
            modelViewer.object.children[3].material.color.b = 0.81;
            modelViewer.object.children[3].material.bumpScale = 0.02;
            modelViewer.object.children[3].material.shininess = 5.75;
            modelViewer.object.children[3].material.specular.r = 0.05;
            modelViewer.object.children[3].material.specular.g = 0.05;
            modelViewer.object.children[3].material.specular.b = 0.05;
            modelViewer.object.children[3].scale.y = 1;
            modelViewer.object.children[3].position.z = 0;
            modelViewer.object.children[1].scale.y = 1;
            modelViewer.object.children[1].position.z = 0;
            modelViewer.object.children[3].material.reflectivity = 0.025;
            modelViewer.object.children[1].material.reflectivity = 1;
            break;
        case '438': // Seatbelt, Black
            modelViewer.object.children[3].material.map.image = modelViewer.product.textures[4].image;
            modelViewer.object.children[3].material.bumpMap.image = modelViewer.product.textures[4].image;
            modelViewer.object.children[3].material.color.r = 0.3;
            modelViewer.object.children[3].material.color.g = 0.3;
            modelViewer.object.children[3].material.color.b = 0.29;
            modelViewer.object.children[3].material.bumpScale = 0.001;
            modelViewer.object.children[3].material.shininess = 250;
            modelViewer.object.children[3].material.specular.r = 0.02;
            modelViewer.object.children[3].material.specular.g = 0.02;
            modelViewer.object.children[3].material.specular.b = 0.02;
            modelViewer.object.children[3].scale.y = 4/3;
            modelViewer.object.children[3].position.z = -0.005;
            modelViewer.object.children[1].scale.y = 4/3;
            modelViewer.object.children[1].position.z = -0.005;
            modelViewer.object.children[3].material.reflectivity = 0.1;
            modelViewer.object.children[1].material.reflectivity = 1;
            break;
        case '435': // Poly, Black
            modelViewer.object.children[3].material.map.image = modelViewer.product.textures[1].image;
            modelViewer.object.children[3].material.bumpMap.image = modelViewer.product.textures[1].image;
            modelViewer.object.children[3].material.color.r = 0.20;
            modelViewer.object.children[3].material.color.g = 0.18;
            modelViewer.object.children[3].material.color.b = 0.16;
            modelViewer.object.children[3].material.bumpScale = 0.002;
            modelViewer.object.children[3].material.shininess = 5.75;
            modelViewer.object.children[3].material.specular.r = 0.05;
            modelViewer.object.children[3].material.specular.g = 0.05;
            modelViewer.object.children[3].material.specular.b = 0.05;
            modelViewer.object.children[3].scale.y = 1;
            modelViewer.object.children[3].position.z = 0;
            modelViewer.object.children[1].scale.y = 1;
            modelViewer.object.children[1].position.z = 0;
            modelViewer.object.children[3].material.reflectivity = 0.05;
            modelViewer.object.children[1].material.reflectivity = 1;
            break;
        case '431': // Poly, Gray
            modelViewer.object.children[3].material.map.image = modelViewer.product.textures[1].image;
            modelViewer.object.children[3].material.bumpMap.image = modelViewer.product.textures[1].image;
            modelViewer.object.children[3].material.color.r = 0.5;
            modelViewer.object.children[3].material.color.g = 0.5;
            modelViewer.object.children[3].material.color.b = 0.46;
            modelViewer.object.children[3].material.bumpScale = 0.002;
            modelViewer.object.children[3].material.shininess = 5.75;
            modelViewer.object.children[3].material.specular.r = 0.05;
            modelViewer.object.children[3].material.specular.g = 0.05;
            modelViewer.object.children[3].material.specular.b = 0.05;
            modelViewer.object.children[3].scale.y = 1;
            modelViewer.object.children[3].position.z = 0;
            modelViewer.object.children[1].scale.y = 1;
            modelViewer.object.children[1].position.z = 0;
            modelViewer.object.children[3].material.reflectivity = 0.05;
            modelViewer.object.children[1].material.reflectivity = 1;
            break;
        case '436': // Poly, Purple
            modelViewer.object.children[3].material.map.image = modelViewer.product.textures[1].image;
            modelViewer.object.children[3].material.bumpMap.image = modelViewer.product.textures[1].image;
            modelViewer.object.children[3].material.color.r = 0.4;
            modelViewer.object.children[3].material.color.g = 0.2;
            modelViewer.object.children[3].material.color.b = 0.7;
            modelViewer.object.children[3].material.bumpScale = 0.002;
            modelViewer.object.children[3].material.shininess = 5.75;
            modelViewer.object.children[3].material.specular.r = 0.05;
            modelViewer.object.children[3].material.specular.g = 0.05;
            modelViewer.object.children[3].material.specular.b = 0.05;
            modelViewer.object.children[3].scale.y = 1;
            modelViewer.object.children[3].position.z = 0;
            modelViewer.object.children[1].scale.y = 1;
            modelViewer.object.children[1].position.z = 0;
            modelViewer.object.children[3].material.reflectivity = 0.05;
            modelViewer.object.children[1].material.reflectivity = 1;
            break;
        case '433': // Poly, Orange
            modelViewer.object.children[3].material.map.image = modelViewer.product.textures[1].image;
            modelViewer.object.children[3].material.bumpMap.image = modelViewer.product.textures[1].image;
            modelViewer.object.children[3].material.color.r = 1;
            modelViewer.object.children[3].material.color.g = 0.45;
            modelViewer.object.children[3].material.color.b = 0;
            modelViewer.object.children[3].material.bumpScale = 0.002;
            modelViewer.object.children[3].material.shininess = 5.75;
            modelViewer.object.children[3].material.specular.r = 0.05;
            modelViewer.object.children[3].material.specular.g = 0.05;
            modelViewer.object.children[3].material.specular.b = 0.05;
            modelViewer.object.children[3].scale.y = 1;
            modelViewer.object.children[3].position.z = 0;
            modelViewer.object.children[1].scale.y = 1;
            modelViewer.object.children[1].position.z = 0;
            modelViewer.object.children[3].material.reflectivity = 0.05;
            modelViewer.object.children[1].material.reflectivity = 1;
            break;
        case '430': // Poly, Red
            modelViewer.object.children[3].material.map.image = modelViewer.product.textures[1].image;
            modelViewer.object.children[3].material.bumpMap.image = modelViewer.product.textures[1].image;
            modelViewer.object.children[3].material.color.r = 0.9;
            modelViewer.object.children[3].material.color.g = 0.09;
            modelViewer.object.children[3].material.color.b = 0.13;
            modelViewer.object.children[3].material.bumpScale = 0.002;
            modelViewer.object.children[3].material.shininess = 5.75;
            modelViewer.object.children[3].material.specular.r = 0.05;
            modelViewer.object.children[3].material.specular.g = 0.05;
            modelViewer.object.children[3].material.specular.b = 0.05;
            modelViewer.object.children[3].scale.y = 1;
            modelViewer.object.children[3].position.z = 0;
            modelViewer.object.children[1].scale.y = 1;
            modelViewer.object.children[1].position.z = 0;
            modelViewer.object.children[3].material.reflectivity = 0.05;
            modelViewer.object.children[1].material.reflectivity = 1;
            break;
        case '434': // Poly, Pink
            modelViewer.object.children[3].material.map.image = modelViewer.product.textures[1].image;
            modelViewer.object.children[3].material.bumpMap.image = modelViewer.product.textures[1].image;
            modelViewer.object.children[3].material.color.r = 1;
            modelViewer.object.children[3].material.color.g = 0.4;
            modelViewer.object.children[3].material.color.b = 0.5;
            modelViewer.object.children[3].material.bumpScale = 0.002;
            modelViewer.object.children[3].material.shininess = 5.75;
            modelViewer.object.children[3].material.specular.r = 0.05;
            modelViewer.object.children[3].material.specular.g = 0.05;
            modelViewer.object.children[3].material.specular.b = 0.05;
            modelViewer.object.children[3].scale.y = 1;
            modelViewer.object.children[3].position.z = 0;
            modelViewer.object.children[1].scale.y = 1;
            modelViewer.object.children[1].position.z = 0;
            modelViewer.object.children[3].material.reflectivity = 0.05;
            modelViewer.object.children[1].material.reflectivity = 1;
            break;
        case '432': // Poly, Blue
            modelViewer.object.children[3].material.map.image = modelViewer.product.textures[1].image;
            modelViewer.object.children[3].material.bumpMap.image = modelViewer.product.textures[1].image;
            modelViewer.object.children[3].material.color.r = 0.14;
            modelViewer.object.children[3].material.color.g = 0.42;
            modelViewer.object.children[3].material.color.b = 0.70;
            modelViewer.object.children[3].material.bumpScale = 0.002;
            modelViewer.object.children[3].material.shininess = 5.75;
            modelViewer.object.children[3].material.specular.r = 0.05;
            modelViewer.object.children[3].material.specular.g = 0.05;
            modelViewer.object.children[3].material.specular.b = 0.05;
            modelViewer.object.children[3].scale.y = 1;
            modelViewer.object.children[3].position.z = 0;
            modelViewer.object.children[1].scale.y = 1;
            modelViewer.object.children[1].position.z = 0;
            modelViewer.object.children[3].material.reflectivity = 0.05;
            modelViewer.object.children[1].material.reflectivity = 1;
            break;
        case '437': // Poly, Rainbow
            modelViewer.object.children[3].material.map.image = modelViewer.product.textures[3].image;
            modelViewer.object.children[3].material.bumpMap.image = modelViewer.product.textures[2].image;
            modelViewer.object.children[3].material.color.r = 1;
            modelViewer.object.children[3].material.color.g = 1;
            modelViewer.object.children[3].material.color.b = 1;
            modelViewer.object.children[3].material.bumpScale = 0.025;
            modelViewer.object.children[3].material.shininess = 5.75;
            modelViewer.object.children[3].material.specular.r = 0.05;
            modelViewer.object.children[3].material.specular.g = 0.05;
            modelViewer.object.children[3].material.specular.b = 0.05;
            modelViewer.object.children[3].scale.y = 4/3;
            modelViewer.object.children[3].position.z = -0.005;
            modelViewer.object.children[1].scale.y = 4/3;
            modelViewer.object.children[1].position.z = -0.005;
            modelViewer.object.children[3].material.reflectivity = 0.05;
            modelViewer.object.children[1].material.reflectivity = 1;
            break;
    }
    modelViewer.object.children[3].material.needsUpdate = true;
    modelViewer.object.children[3].material.map.needsUpdate = true;
    modelViewer.object.children[3].material.bumpMap.needsUpdate = true;
    modelViewer.object.children[3].material.map.minFilter = THREE.LinearMipMapLinearFilter;
    modelViewer.object.children[3].material.bumpMap.minFilter = THREE.LinearMipMapLinearFilter;
};

window.Products.Bag.DayTote.prototype.setThreeControls = function(controls) {
    controls.minDistance = 2.3;
    controls.maxDistance = 3.4;
};